import React from 'react'

import { CloudinaryImage } from 'ethos-design-system'

const RatingImages = () => {
  return (
    <div className="flex items-center justify-center pb-8 pt-12">
      <div className={'mr-16 w-[130px]'}>
        <CloudinaryImage
          publicId={
            'https://res.cloudinary.com/getethos/image/upload/v1676493336/00_CMS/trustPilotLogoWithStars_tk7u4q.png'
          }
          alt={'TrustPilot Review Stars'}
          crop={CloudinaryImage.CROP_METHODS.FILL}
        />
        <div className="mt-3 flex items-center justify-center">
          <p className="m-0 mr-1.5 text-sm font-medium">4.8/5</p>
          <p className="m-0 text-sm">1900 reviews</p>
        </div>
      </div>

      <div className="w-[100px]">
        <CloudinaryImage
          publicId={
            'https://res.cloudinary.com/getethos/image/upload/v1724137590/image_71_gjxfuj.svg'
          }
          alt={'BBB'}
          crop={CloudinaryImage.CROP_METHODS.FIT}
          height={[180, 180, 120, 120]}
          width={[180, 180, 120, 120]}
        />
      </div>
    </div>
  )
}

export default RatingImages
